import type { MenuItem } from './types';

/** Coincide si la ruta es igual o sigue con '/'. */
const prefixMatches = (itemPath: string, currentPath: string) => {
  if (!itemPath || itemPath === '#') return false;
  if (currentPath === itemPath) return true;
  if (!currentPath.startsWith(itemPath)) return false;
  const nextChar = currentPath[itemPath.length];
  return nextChar === '/' || nextChar === undefined;
};

/**
 * Longitud de la ruta más específica del item que coincide con `currentPath`
 * (su `path` o alguna de sus `activePaths`); 0 si ninguna. El menú marca el
 * hijo con la coincidencia más larga.
 */
export const menuItemMatchLength = (item: MenuItem, currentPath: string): number => {
  if (item.external) return 0;
  const candidates = [item.path, ...(item.activePaths ?? [])].filter((path): path is string => Boolean(path));
  return candidates.reduce(
    (best, path) => (prefixMatches(path, currentPath) && path.length > best ? path.length : best),
    0,
  );
};
